"use strict";

var LoggerInstance = require("js-logger").get("AccountActions");

var AccountApi = require("../api/AccountApi");

var ActionsHelper = require("../actions/ActionsHelper");

var Spinner = require("../client/Spinner");

var AccountDemographicsHelper = require("../commonComponents/AccountDemographicsHelper");
var PaymentHelper = require("../commonComponents/PaymentHelper");
var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var AccountCommunicationsHelper = require("./AccountCommunicationsHelper");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");
var Dispatcher = require("./Dispatcher");
var DocumentsHelper = require("./DocumentsHelper");
var GivingStatementHelper = require("./GivingStatementHelper");
var PhoneNumberHelper = require("./PhoneNumberHelper");
var PledgeStatementHelper = require("./PledgeStatementHelper");
var ReportsHelper = require("./ReportsHelper");
var SmartyStreets = require("./SmartyStreets");
var SavedPaymentHelper = require("./SavedPaymentHelper");
var MyRelationshipPledgesHelper = require("./MyRelationshipPledgesHelper");

var setProperty = (model, propertyName, propertyValue) => {
	var propertyParts = propertyName.split(".");
	var ref = model;
	propertyParts.forEach(function (propertyPart, index) {
		if (index < propertyParts.length - 1) {
			if (!ref[propertyPart]) {
				ref[propertyPart] = {};
			}
			ref = ref[propertyPart];
		} else {
			ref[propertyPart] = propertyValue;
		};
	});
};

/*
	Currently this is the only place where I see this being needed.
	If we find another use for it, it should probably be moved to
	a shared location/utility class.
*/
var _parseUri = (uri) => {
	var anchorTag = document.createElement("a");
	anchorTag.href = uri;

	return {
		host: anchorTag.host,
		href: anchorTag.href
	};
};

var AccountActions = {
	initializeAccount: function (options) {
		options = options || {};
		document.addEventListener("DOMContentLoaded", function (event) {
			if (!options.isDesignMode) {
				SmartyStreets.initializeForPrimaryContactInformation();
				SmartyStreets.initializeForOtherAddressesAdd();
				AccountActions.initializePhoneNumberGroupComponent(options.primaryAddressCountry);
				AccountActions.initializeProductDownloadUrl();
				GivingStatementHelper.initializeGivingStatementRequestForm();
				MyRecurringHelper.initializeMyRecurring();
				MyPledgesHelper.initializeMyPledges();
				MyRelationshipPledgesHelper.initializeMyRelationshipPledges();
				MySponsorshipsHelper.initializeMySponsorships();
				SavedPaymentHelper.initializeSavedPayments(/*isCheckout*/false);
			}
			AccountActions.initializeSpouseInformationComponent();
		});
		AccountActions.initializeStore(options);
	},

	initializeStore: function (options) {
		document.addEventListener("DOMContentLoaded", function (event) {
			if (!options.isDesignMode) {
				PaymentHelper.initializePaymentComponent();
			}

			DocumentsHelper.initialize(options.isDesignMode);
		});

		if ((options.wizardAddressStandardization || {}).isEnabled) {
			AccountApi.getAutoAddStateAndPostalCodesControlRecord().done((controlRecord) => {
				Dispatcher.dispatch({
					actionType: AccountConstants.SET_AUTO_ADD_STATE_AND_POSTAL_CODES,
					isAutoAddStateAndPostalCodes: controlRecord.value === "Y"
				});
			})
		}

		Dispatcher.dispatch(Object.assign({
			actionType: Constants.ACCOUNT_INITIALIZE
		}, options));

		AccountActions.initializeAccountType();
		AccountActions.initializeDemographics();
		AccountActions.initializeAccountMediaForm();
		AccountActions.initializeAccountCommunicationForm(options);
		AccountActions.initializeReports(options);

		AccountFormHelper.initializeAccountEmailCustomValidator();
	},

	isDesignMode: function() {
		return AccountStore.get("isDesignMode");
	},

	changePassword: function (event) {
		try {
			event = this._getEventOrReturn(event, "Password change called successfully.");
			if (!event) {
				return;
			}

			Spinner.showSpinner();

			var currentPassword = $(event.target).find("input[name='currentPassword']").val();
			var newPassword = $(event.target).find("input[name='newPassword']").val();
			var confirmPassword = $(event.target).find("input[name='confirmPassword']").val();

			if (newPassword !== confirmPassword) {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_PASSWORDS_MISMATCH
				));
				Spinner.removeSpinner();
				return;
			}

			var options = {
				currentPassword,
				newPassword
			};

			AccountFormHelper.encodePassword(options, "currentPassword");
			AccountFormHelper.encodePassword(options, "newPassword");

			AccountApi.changePassword(options).then(() => {
				SubmitButtonHelper.performPostSubmitAction("[data-component='changePasswordForm']");
			}, (jqHXR) => {
				var message = ((jqHXR || {}).responseJSON || {}).message || AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.PASSWORD_CHANGE_ERROR
				);
				BootstrapPrompt.alert(message);
				Spinner.removeSpinner();
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	changePrimaryContactInformation: function (event) {
		try {
			event = this._getEventOrReturn(event, "Primary contact information change called successfully.");
			if (!event) {
				return;
			}

			var components = [
				$(event.target).closest("[data-component='primaryContactInformation']")
			];

			var savedPaymentsDisplayMessagesWizard = AccountStore.get("wizardSavedPaymentsDisplayMessages") || {};
			var $singleAddress = $(event.target).closest("[data-component='primaryContactInformation']");

			var that = this;
			var submitPrimaryContactInformation = function (data, shouldUpdateSavedPayments) {
				Spinner.showSpinner();
				ValidationHelper.validate({ components }).always(isValid => {
					if (!isValid) {
						Spinner.removeSpinner();
						return;
					}

					SmartyStreets.verifyAddress("primaryContactInformation").done(() => {
						data.address.shouldUpdateSavedPayments = shouldUpdateSavedPayments;

						AccountApi.changePrimaryContactInformation(data).done(() => {
							SubmitButtonHelper.performPostSubmitAction("[data-component='primaryContactInformation']", {
								shouldForceReloadOnStay: data.address.haveAddressDefaultsChanged || shouldUpdateSavedPayments === false
							});
						}).fail((jqXHR, textStatus, errorThrown) => {
							ApiHelper.displayErrorMessage(jqXHR);
							Spinner.removeSpinner();
						});
					}).fail(() => Spinner.removeSpinner());
				});
			}

			that.serializePrimaryContactInformationForm().always(data => {
				if ($singleAddress.attr("data-is-saved-payment-billing-address") === "True" && data.address.hasAddressChanged) {
					BootstrapPrompt.show({
						message: savedPaymentsDisplayMessagesWizard.savedPaymentAddressEditPromptText,
						buttons: [{
							label: window.BUTTON_LABELS.YES,
							action: (dialog) => {
								dialog.close();
								submitPrimaryContactInformation(data, /*shouldUpdateSavedPayments*/ true);
							}
						}, {
							label: window.BUTTON_LABELS.NO,
							action: (dialog) => {
								dialog.close();
								submitPrimaryContactInformation(data, /*shouldUpdateSavedPayments*/ false);
							}
						}, {
							label: window.BUTTON_LABELS.CANCEL,
							action: (dialog) => {
								dialog.close();
							}
						}]
					});
				} else {
					submitPrimaryContactInformation(data, /*shouldUpdateSavedPayments*/ null);
				}
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	changeSpouseInformation: function (event) {
		try {
			event = this._getEventOrReturn(event, "Spouse information change called successfully.");
			if (!event) {
				return;
			}

			var components = [
				$(event.target).closest("[data-component='spouseInformation']")
			];

			Spinner.showSpinner();
			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				var data = ActionsHelper.serializeForm("[data-component='spouseInformation'] form#spouseInformationForm");

				AccountApi.changeSpouseInformation(data).done(() => {
					SubmitButtonHelper.performPostSubmitAction("[data-component='spouseInformation']");
				}).fail((jqXHR, textStatus, errorThrown) => {
					ApiHelper.displayErrorMessage(jqXHR);
				}).always(() => Spinner.removeSpinner());
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	saveAccountMedia: function (event) {
		try {
			event = this._getEventOrReturn(event, "Account Media Form save called successfully.");
			if (!event) {
				return;
			}

			var components = [$(event.target).closest("form#accountMediaForm")];

			Spinner.showSpinner();
			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				var data = ActionsHelper.serializeForm($(event.target).closest("form#accountMediaForm"));

				AccountApi.saveAccountMedia(data).done(() => {
					SubmitButtonHelper.performPostSubmitAction("[data-component='accountMediaForm']");
				}).fail((jqXHR, textStatus, errorThrown) => {
					ApiHelper.displayErrorMessage(jqXHR);
				}).always(() => Spinner.removeSpinner());
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	createAccount: function (event) {
		try {
			event = this._getEventOrReturn(event, "Account creation action called successfully.");
			if (!event) {
				return;
			}

			var components = [
				$("[data-component='accountDemographicsForm']"),
				$("[data-component='accountMediaForm']"),
				$(event.target).closest("[data-component='createAccountForm']")
			];

			Spinner.showSpinner();
			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				SmartyStreets.verifyAddress("createAccountForm").done(() => {
					var passwordVerificationResult = this.verifyCreateAccountPasswords();
					if (!passwordVerificationResult.isVerified) {
						Spinner.removeSpinner();
						return;
					}

					AccountFormHelper.serializeDataNecessaryToCreateAnAccount().always(accountData => {
						if (AccountActions.getOneTimePasswordRequired()) {
							AccountFormHelper.validateOneTimePassword(
								event
							).done(oneTimePassword => {
								accountData.verificationCode = oneTimePassword;
								AccountActions._submitCreateAccount(accountData);
							}).fail(() => {
								Spinner.removeSpinner();
							});
						} else {
							AccountActions._submitCreateAccount(accountData);
						}
					});
				}).fail(() => Spinner.removeSpinner());
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			Spinner.removeSpinner();
		} finally {
			return false;
		}
	},

	_submitCreateAccount: function (accountData) {
		AccountApi.createAccount(accountData).then((apiData) => {
			//Look if One-Time Password Failed
			if (apiData.success == false) {
				BootstrapPrompt.alert(apiData.message);
				var oneTimePasswordMessages = this.getOneTimePasswordForCreateAccountMessages();
				if (oneTimePasswordMessages && oneTimePasswordMessages.invalidOneTimePassword == apiData.message) {
					//The one-time password was incorrect.  Reshow the message
					var deferred = new $.Deferred();

					window.OneTimePasswordHelper.showOneTimePasswordModal(deferred);
					deferred.done((oneTimePassword) => {
						accountData.verificationCode = oneTimePassword;
						AccountActions._submitCreateAccount(accountData);
					}).fail(() => {
						Spinner.removeSpinner();
					});
				}
			} else {
				SubmitButtonHelper.performPostSubmitAction("[data-component='createAccountForm']");
			}
		}, (jqXHR) => {
			// Message is nested a layer deeper than usual because the SO AccountController returns
			// an ObjectResponse that contains the result of the SE API call.
			// TODO - US#5036 Enhance error handling for ASO account creation messages.

			this.handleAccountCreateResponse(
				jqXHR.responseJSON,
				true /* hideSpinner */
			);
		});
	},

	handleAccountCreateResponse: function(apiResponse, hideSpinner) {
		AccountFormHelper.handleAccountCreateResponse(
			AccountStore,
			apiResponse,
			hideSpinner
		);
	},

	deleteSavedPayment: function (paymentRecordId) {
		SavedPaymentHelper.deleteSavedPayment(paymentRecordId);
	},

	performLogin: function (event) {
		try {
			event = this._getEventOrReturn(event, "Login action called successfully.");
			if (!event) {
				return;
			}

			Spinner.showSpinner();

			//pull login form data
			var data = $("[data-component='loginForm'] form").serializeArray().reduce((obj, item) => {
				setProperty(obj, item.name, item.value);
				return obj;
			}, {});
			AccountFormHelper.encodePassword(data);

			var actionData = SubmitButtonHelper.getPostSubmitActionData("[data-component='loginForm']");

			AccountApi.performLogin(data).then(() => {
				var contactusUrl = sessionStorage.getItem("contactusUrl");
				if (contactusUrl) {
					window.location.href = contactusUrl;
					return;
				}

				var accountStoreState = AccountStore.getState();
				var runFallbackAction = false;

				if (actionData.returnToReferrer) {
					// check previous URL
					if (document.referrer === "") {
						runFallbackAction = true;
					} else {
						var referrer = _parseUri(document.referrer);
						var currentUrl = _parseUri(window.location.href);

						if (referrer.host !== currentUrl.host) {
							var isValidReferrer = false;

							// check the whitelist
							var domainWhitelist = accountStoreState.domainWhitelist;
							if (domainWhitelist.length) {
								isValidReferrer = domainWhitelist.some((domainString) => referrer.host === domainString);
							}

							if (isValidReferrer) {
								window.location.href = referrer.href;
							} else {
								runFallbackAction = true;
							}

						} else {
							// The only scenario we don't want to navigate back to is /resetpassword
							if (referrer.href.toLowerCase().indexOf("/resetpassword") !== -1) {
								runFallbackAction = true;
							} else {
								// perform navigation to referring URL.
								window.location.href = referrer.href;
							}
						}
					}
				}

				if (!actionData.returnToReferrer || runFallbackAction) {
					SubmitButtonHelper.performPostSubmitAction("[data-component='loginForm']", { actionData });
				}
			}, /* failure callback */ (jqXHR) => {
				if (jqXHR.status === 403) {
					BootstrapPrompt.alert(AccountStore.getWizardValue(
						WizardConstants.WIZARDS.LOGIN_MESSAGES,
						WizardConstants.LOGIN_MESSAGE_FIELDS.LOGIN_ERROR
					));
				}

				Spinner.removeSpinner();
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	resetPassword: function (event) {
		try {
			event = this._getEventOrReturn(event, "Reset password action called successfully.");
			if (!event) {
				return;
			}

			Spinner.showSpinner();

			var newPassword = $(event.target).find("input[name='newPassword']").val();
			var confirmPassword = $(event.target).find("input[name='confirmPassword']").val();
			var resetToken = ApiHelper.getUrlParameter("resetToken");
			var emailAddress = ApiHelper.getUrlParameter("emailAddress");


			if (newPassword !== confirmPassword) {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_PASSWORDS_MISMATCH
				));
				Spinner.removeSpinner();
				return;
			}

			if (emailAddress === null || emailAddress === undefined) {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.EMAIL_MISSING
				));
				Spinner.removeSpinner();
				return;
			}

			if (resetToken === null || resetToken === undefined) {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.RESET_TOKEN_MISSING
				));
				Spinner.removeSpinner();
				return;
			}

			var options = {
				emailAddress,
				newPassword,
				resetToken
			};

			AccountFormHelper.encodePassword(options, "newPassword");
			AccountFormHelper.encodePassword(options, "confirmPassword");

			AccountApi.resetPassword(options).done(() => {
				SubmitButtonHelper.performPostSubmitAction("[data-component='resetPasswordForm']");
			}).fail((response) => {
				var message = ((response || {}).responseJSON || {}).message || AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.PASSWORD_CHANGE_ERROR
				);
				BootstrapPrompt.alert(message);
				Spinner.removeSpinner();
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	sendPasswordResetEmail: function (event) {
		try {
			event = this._getEventOrReturn(event, "Password reset email sent successfully.");
			if (!event) {
				return;
			}

			Spinner.showSpinner();

			var $emailInput = $(event.target).find("input[name='emailAddress']");

			AccountApi.sendPasswordResetEmail($emailInput.val()).done(() => {
				var postActionUndefinedOrNoMessage = () => {
					// If there is a forgotPasswordSubmitMessage defined, show it.
					$("[data-component='forgotPasswordForm'] [data-component='forgotPasswordForm.submitMessage']").show();
				};

				SubmitButtonHelper.performPostSubmitAction("[data-component='forgotPasswordForm']", {
					onNoPostSubmitAction: postActionUndefinedOrNoMessage,
					onNoStayMessage: postActionUndefinedOrNoMessage
				});
			}).fail((response) => {
				var message = ((response || {}).responseJSON || {}).message || AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.FORGOT_PASSWORD_ERROR
				);
				BootstrapPrompt.alert(message);
				Spinner.removeSpinner();
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	processAddSavedPaymentToAccount: function (event) {
		SavedPaymentHelper.addSavedPaymentToAccount(event);
	},

	showAddNewPayment: function (event) {
		SavedPaymentHelper.handleAddNewPaymentLinkClick(event);
	},

	submitPledgeStatementForm: function (event) {
		PledgeStatementHelper.submitPledgeStatementForm(event);
	},

	getAccountType: function(accountData) {
		return AccountApi.getAccountType(accountData);
	},

	getAccountCodes: function() {
		return AccountStore.get("accountCodes");
	},

	getLoggedInAccount: function () {
		var account = AccountStore.get("account");
		if (account && account.loggedInStatus === "loggedIn") {
			account.otherAddresses = this.getOtherAddresses();
			return account;
		}

		return {};
	},

	getOtherAddresses: function () {
		return AccountStore.get("otherAddresses");
	},

	getIsAutoAddStateAndPostalCodes: function (formParentId) {
		return AccountStore.get("isAutoAddStateAndPostalCodes");
	},

	getDefaultCountry: function () {
		return AccountStore.getDefaultCountry();
	},

	getSelectedCountry: function (formParentId) {
		return AccountStore.getSelectedCountry(formParentId) || this.getDefaultCountry();
	},

	getSelectedEmailType: function (formParentId) {
		return AccountStore.getSelectedEmailType(formParentId);
	},

	getSelectedOrganizationType: function (formParentId) {
		return AccountStore.getSelectedOrganizationType(formParentId);
	},

	getSelectedPaymentType: function(uniqueName) {
		return AccountStore.getSelectedPaymentType(uniqueName);
	},

	getSelectedPhoneType: function (formParentId) {
		return AccountStore.getSelectedPhoneType(formParentId);
	},

	getSelectedState: function (formParentId) {
		return AccountStore.getSelectedState(formParentId);
	},

	getSelectedTitle: function (formParentId) {
		return AccountStore.getSelectedTitle(formParentId);
	},

	getSelectedMediaOutlet: function() {
		return AccountStore.get("selectedMediaOutlet");
	},

	getPreviousMediaRequest: function() {
		return AccountStore.get("previousMediaRequest");
	},

	getAvailableMediaValues: function() {
		return AccountStore.get("availableMediaValues");
	},

	getIsFormInputDisabled: function (formParentId) {
		if (!formParentId) {
			LoggerInstance.error("A 'formParentId' parameter should be passed into getIsFormInputDisabled.");
			return null;
		}

		return AccountStore.getIsFormInputDisabled(formParentId);
	},

	getPlaidDisplayMessages: function () {
		return AccountStore.get("wizardPlaidDisplayMessages") || {};
	},

	getOneTimePasswordRequired: function () {
		return (AccountStore.get("wizardOneTimePasswordConfiguration") || {}).oneTimePasswordForCreateAccountEnabled === "Y";
	},

	getOneTimePasswordForCreateAccountMessages: function () {
		return AccountStore.get("wizardOneTimePasswordForCreateAccountMessages") || {};
	},

	setSelectedCountry: function (formParentId, selectedCountry) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_COUNTRY,
			formParentId,
			selectedCountry
		});
	},

	setSelectedEmailType: function (formParentId, selectedEmailType) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_EMAIL_TYPE,
			formParentId,
			selectedEmailType
		});
	},

	setSelectedOrganizationType: function (formParentId, selectedOrganizationType) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_ORGANIZATION_TYPE,
			formParentId,
			selectedOrganizationType
		});
	},

	setSelectedPaymentType: function(uniqueName, selectedPaymentType) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_PAYMENT_TYPE,
			uniqueName,
			selectedPaymentType
		});
	},

	setSelectedPhoneType: function (formParentId, selectedPhoneType) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_PHONE_TYPE,
			formParentId,
			selectedPhoneType
		});
	},

	setSelectedState: function (formParentId, selectedState) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_STATE,
			formParentId,
			selectedState
		});
	},

	setSelectedTitle: function (formParentId, selectedTitle) {
		Dispatcher.dispatch({
			actionType: AccountConstants.SET_SELECTED_TITLE,
			formParentId,
			selectedTitle
		});
	},

	setSelectedMediaOutlet: function (selectedMediaOutlet) {
		AccountStore.setStateByType(AccountConstants.SET_MEDIA_OUTLET, selectedMediaOutlet);
	},

	setPreviousMediaRequest: function (previousMediaRequest) {
		AccountStore.setStateByType(AccountConstants.SET_PREVIOUS_MEDIA_REQUEST, previousMediaRequest);
	},

	setAvailableMediaValues: function (availableValues) {
		AccountStore.setStateByType(AccountConstants.SET_AVAILABLE_MEDIA_VALUES, availableValues);
	},

	verifyCreateAccountPasswords: function (doNotShowAlert) {
		// determine if we have a confirmPassword on the form, and if so make sure values match.
		var $confirmPasswordField = $("[data-component='createAccountForm.confirmPassword']");

		if ($confirmPasswordField.length) {
			var password = $("[data-component='createAccountForm.password']").val();
			var confirmPassword = $confirmPasswordField.val();

			if (password !== confirmPassword) {
				var passwordMismatchErrorMessage = window.AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_PASSWORDS_MISMATCH
				);

				if (!doNotShowAlert) {
					BootstrapPrompt.alert(passwordMismatchErrorMessage);
				}

				return {
					isVerified: false, errorMessage: passwordMismatchErrorMessage
				};
			}
		}

		return { isVerified: true };
	},

	serializeCreateGiftAccountForm: function () {
		return AccountFormHelper.serializeAddressForm("[data-component='createGiftAccountForm'] form", { shouldEncodePassword: false });
	},

	serializeAddOtherAddressForm: function() {
		return AccountFormHelper.serializeAddressForm("[data-component='otherAddresses.addForm'] form", { shouldEncodePassword: false });
	},

	serializePrimaryContactInformationForm: function () {
		var deferred = new $.Deferred();

		//Do not need to get mediaOutlet because on the account page, it will either be in the primaryContactInformationForm or in a form of its own with a Submit button.
		var serializedAddressData = AccountFormHelper.serializeAddressForm("[data-component='primaryContactInformation'] form#primaryContactInformationForm", { shouldEncodePassword: false });
		AccountFormHelper.updateAccountDemographics(serializedAddressData, $("[data-component='primaryContactInformation']")).always(() => {
			deferred.resolve(serializedAddressData);
		});
		return deferred;
	},

	initializeAccountType: function() {
		// If there are two that are visible
		if ($("[data-component='accountType'] > div").length == 2) {
			var $accountTypeSelect = $("[data-component='createAccountForm.accountTypeSelector']");
			if ($("[data-component='accountType'] > div:visible").length > 1) {
				var $individual = $(`[data-component='accountType'] > div[data-component='${Constants.ACCOUNT_TYPES.INDIVIDUAL}']`);
				var $organization = $(`[data-component='accountType'] > div[data-component='${Constants.ACCOUNT_TYPES.ORGANIZATION}']`);
				var individualEmpty = $individual.children().length == 0;
				var organizationEmpty = $organization.children().length == 0;
				if (individualEmpty && !organizationEmpty) {
					$accountTypeSelect.val("organization").trigger("change");
				} else {
					$accountTypeSelect.val("individual").trigger("change");
				}
			} else {
				var selectedValue = $accountTypeSelect.val();

				if (!$(`[data-component="accountType"] > div[data-component="accountType.${selectedValue}"]:visible`).length) {
					$accountTypeSelect.trigger("change");
				}
			}
		}
	},

	initializeAccountMediaForm: function() {
		$("[data-component='accountMediaForm'] form").off("submit.accountMediaForm");
		$("[data-component='accountMediaForm'] form").on("submit.accountMediaForm", AccountActions.saveAccountMedia.bind(this));
	},

	initializeAccountCommunicationForm: function (options) {
		$("[data-component='accountCommunicationForm'] form").off("submit.accountCommunicationForm");
		$("[data-component='accountCommunicationForm'] form").on("submit.accountCommunicationForm", AccountActions.createCommunication.bind(this));

		AccountCommunicationsHelper.initializeNumbers();

		var dateFormat = (options.wizardDateFormat && options.wizardDateFormat.dateFormat) || {};
		AccountCommunicationsHelper.initializeDates(dateFormat);
	},

	initializeReports: function (options) {
		ReportsHelper.initialize(options);
	},

	downloadDocument: function (event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("documentsDownload"));
		if (!event) {
			return false;
		}

		event.preventDefault();

		var $document = $(event.target).closest("[data-component='documents.populated.document']");
		var documentCode = $document.attr("data-document-code");

		Spinner.showSpinner($document);
		var shouldOpenPdfDocumentsInNewTab = AccountStore.getWizardValue(
			WizardConstants.WIZARDS.DOCUMENTS_CONFIGURATION,
			WizardConstants.DOCUMENTS_COFIGURATION_FIELDS.SHOULD_OPEN_PDF_IN_NEW_TAB
		);

		AccountApi.downloadDocument(documentCode, undefined, shouldOpenPdfDocumentsInNewTab).fail((statusCode) => {
			var message = AccountStore.getWizardValue(
				WizardConstants.WIZARDS.DOCUMENTS_DISPLAY_MESSAGES,
				WizardConstants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS.DOWNLOAD_ERROR
			);

			switch (statusCode) {
				case 404:
					message = AccountStore.getWizardValue(
						WizardConstants.WIZARDS.DOCUMENTS_DISPLAY_MESSAGES,
						WizardConstants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS.DOWNLOAD_UNAVAILABLE
					);
					break;
				case 401:
					message = AccountStore.getWizardValue(
						WizardConstants.WIZARDS.DOCUMENTS_DISPLAY_MESSAGES,
						WizardConstants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS.DOWNLOAD_UNAUTHORIZED
					);
					break;
				default:
					break;
			}

			BootstrapPrompt.alert(message);
		}).always(() => {
			Spinner.removeSpinner($document);
		});

		return false;
	},

	loadDocumentsPartial: function (event, documentTypeCode) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("documentsLoadPartial"));
		if (!event) {
			return false;
		}

		event.preventDefault();

		var $documentsElement = $(event.target).closest("[data-component='documents']");

		var options = {
			documentsComponentId: $documentsElement.attr("id"),
			existingBreadcrumb: this._getParentDocumentTypeBreadcrumb($(event.target), $documentsElement)
		};

		this._loadDocumentTypes($documentsElement, options, documentTypeCode);

		return false;
	},

	_loadDocumentTypes: function ($documentsElement, options, documentTypeCode) {
		options = options || {};

		Spinner.showSpinner($documentsElement);
		AccountApi.getDocumentTypes(documentTypeCode, options).done((data) => {
			$documentsElement.html($(data));
			DocumentsHelper.initialize(this.isDesignMode(), $documentsElement);
			Spinner.removeSpinner($documentsElement);
		}).fail((jqXHR) => {
			jqXHR = jqXHR || {};
			switch (jqXHR.status) {
				case 400: // Partial Missing
					if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
						//There was not a partial error, so do what we normally would do.
						ApiHelper.displayErrorMessage(jqXHR);
					}
					break;
				case 401: // Unauthorized
					Spinner.removeSpinner($documentsElement);

					BootstrapPrompt.alert(AccountStore.getWizardValue(
						WizardConstants.WIZARDS.DOCUMENTS_DISPLAY_MESSAGES,
						WizardConstants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS.DOCUMENT_TYPE_CHANGED
					));

					this._loadDocumentTypes($documentsElement, {
						documentsComponentId: $documentsElement.attr("id")
					});
					return;
				case 419: // Authentication Timeout
					Spinner.removeSpinner($documentsElement);
					Spinner.showSpinner();
					window.location = "/login"
					return;
				default:
					BootstrapPrompt.alert(AccountStore.getWizardValue(
						WizardConstants.WIZARDS.DOCUMENTS_DISPLAY_MESSAGES,
						WizardConstants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS.DOCUMENT_TYPE_ERROR
					));
					break;
			}

			Spinner.removeSpinner($documentsElement);
		});
	},

	_getParentDocumentTypeBreadcrumb: function ($selectedElement, $documents) {
		var $clickedBreadcrumb = $selectedElement.closest('[data-component="hierarchicalBreadcrumb.item"]');
		if ($clickedBreadcrumb.length) {
			return $clickedBreadcrumb.attr("data-breadcrumb-parents");
		}

		var $clickedDocumentType = $selectedElement.closest('[data-component="documents.populated.documentType"]');
		if ($clickedDocumentType.length) {
			var $currentBreadcrumbItems = $documents.find('[data-component="hierarchicalBreadcrumb.item"]');
			if ($currentBreadcrumbItems.length > 1) {
				var $currentDocumentType = $currentBreadcrumbItems.last();
				var parentBreadcrumb = `${$currentDocumentType.attr("data-breadcrumb-parents")}`;
				var currentDocumentTypeCode = $currentDocumentType.attr("data-document-type-code");
				var currentDocumentTypeTitle = $currentDocumentType.attr("data-document-type-title");
				return parentBreadcrumb + `${currentDocumentTypeCode}|${currentDocumentTypeTitle};`;
			}
		}

		return "";
	},

	initializeDemographics: function (options) {
		options = options || {};
		var parentSelector = options.parentSelector;
		var accountCodes = options.accountCodes;
		var setInitialDirty = options.setInitialDirty;

		var accountCodes = accountCodes || AccountStore.get("accountCodes");

		var $demographicForms;
		var $demographicFormsToDefault;

		if (parentSelector) {
			$demographicForms = $(parentSelector).find("[data-component='accountDemographicsForm']");
			$demographicFormsToDefault = $demographicForms;
		} else {
			// This is called by initializeStore on page load
			$demographicForms = $("[data-component='accountDemographicsForm']");

			// We do not want to default the Account Demographics form fields when we are within the eventRegistration component, because the registrants might not be the logged in user
			$demographicFormsToDefault = $demographicForms.not("[data-component='eventRegistration'] [data-component='accountDemographicsForm']");
		}

		// If constituent is logged in, init the inputs with the values from the AccountCodes cache
		// before the change listeners are set
		if (accountCodes && accountCodes.length > 0 && $demographicFormsToDefault.length > 0) {
			accountCodes.forEach(code => {
				$demographicFormsToDefault.find(`[name="${code.type}"]`).each((index, element) => {
					var $element = $(element);
					var componentName = $element.attr("data-component");
					var $parent;

					if (componentName.startsWith("multipleCheckboxes")) {
						if ($element.attr("value") === code.value) {
							$element.prop("checked", true);
							AccountDemographicsHelper.updateSelectedCheckboxes($element, true);

							if (setInitialDirty) {
								$element.addClass("isDirty");
							}
						}
					} else if (componentName.startsWith("singleCheckbox")) {
						// singleCheckbox support
						$parent = $element.parents("[data-component='singleCheckbox']").first();
						if ($parent) {
							if ($parent.attr("code-type-true-value") === code.value) {
								$element.prop("checked", true);
							} else {
								$element.prop("checked", false);
							}

							if (setInitialDirty) {
								$element.addClass("isDirty");
							}
						}
					} else if (componentName.startsWith("select")) {
						// select support
						$element.find(`option[value=${code.value}]`).prop("selected", true);

						if (setInitialDirty) {
							$element.addClass("isDirty");
						}
					} else if (componentName.startsWith("radioButtons")) {
						// radio buttons support
						if ($element.attr("value") === code.value) {
							$element.prop("checked", true);
							AccountDemographicsHelper.updateSelectedRadioButtons($element);

							if (setInitialDirty) {
								$element.addClass("isDirty");
							}
						}
					}
				});
			});

			// Initialize singleCheckbox to checked if there is no true value and no preexisting account code
			$demographicFormsToDefault.find("[data-component='singleCheckbox'][code-type-true-value='']").each((index, component) => {
				var $component = $(component);
				var codeType = $component.attr("code-type");

				var hasNoAccountCode = !accountCodes.find(code => code.type == codeType);
				if (hasNoAccountCode) {
					var $checkbox = $component.find(`[name='${codeType}']`);
					$checkbox.prop("checked", true);
				}
			});
		}

		// Add listeners
		$demographicForms.each((index, element) => {
			var $element = $(element);
			var $form = $element.find("form").first();

			$form.off("submit.accountDemographicsForm");
			$form.on("submit.accountDemographicsForm", AccountActions.saveDemographics);

			// adding change listeners to the demographic inputs.
			var $demographicInputs = $element.find("[name][type='checkbox'],[name][type='radio'],select[name]");
			$demographicInputs.off("change.accountDemographicsForm");
			$demographicInputs.on("change.accountDemographicsForm", (event) => {
				if (!event || !event.target) {
					return;
				}
				$(event.target).toggleClass("isDirty");

				// Handle setting .selected on required elements when a radio button is selected.
				var $selectedComponent = $(event.target);
				if ($selectedComponent.closest('[data-component="radioButtons"]').length) {
					AccountDemographicsHelper.updateSelectedRadioButtons($selectedComponent);
				} else if ($selectedComponent.closest('[data-component="multipleCheckboxes"]').length) {
					AccountDemographicsHelper.updateSelectedCheckboxes($selectedComponent, $selectedComponent.is(":checked"));
				}
			});
		});
	},

	//Used when submitting a single accountDemographicForm
	saveDemographics: function (event) {
		var $form,
			formDataArray,
			$namedInputs,
			parentComponentName;

		if (!event || !event.target) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		$form = $(event.target);

		if ($form[0].tagName !== "FORM") {
			return;
		}

		// Only the submit button is in the form, all the inputs are outside the form,
		// but inside the accountDemographicForm div
		parentComponentName = $form.attr("data-child-of");
		//We always want to get [data-component='singleCheckbox.input'] because it has a true/false value.
		$namedInputs = $form.parents(`[data-component="${parentComponentName}"]`).first().find("[name].isDirty,[name][required],[data-component='singleCheckbox.input']");
		if ($namedInputs.length <= 0) {
			SubmitButtonHelper.performPostSubmitAction(`[data-component='${parentComponentName}']`);
			return;
		}

		Spinner.showSpinner();
		AccountDemographicsHelper.getDemographics($namedInputs).always((demographicData) => {
			if (demographicData) {
				if (demographicData.length > 0) {
					AccountApi.updateAccountCodes(demographicData).done(() => {
						SubmitButtonHelper.performPostSubmitAction(`[data-component='${parentComponentName}']`);
					}).fail((jqXHR, textStatus, errorThrown) => {
						ApiHelper.displayErrorMessage(jqXHR);
					}).always(() => Spinner.removeSpinner());
				} else {
					SubmitButtonHelper.performPostSubmitAction(`[data-component='${parentComponentName}']`);
				}
			} else {
				Spinner.removeSpinner();
			}
		});
	},

	toggleAccountType: function (event) {
		try {
			if (!event) {
				return;
			}

			var newValue = $(event.target).val();

			// Hide visible one
			$("[data-component='accountType'] > div:visible").not(`[data-component='accountType.${newValue}']`).hide();
			// Show invisible one
			$(`[data-component='accountType'] > div[data-component='accountType.${newValue}']`).show();

			//This line is still here for backwards compatibility.  The code that disables "inputs" for accountType is now in ActionsHelper.serializeForm().
			$("[data-component='accountType'] > div:visible input").prop("disabled", false);

			//Making sure if there are any other accountTypeSelectors on the page, they are set to the correct value
			$("select[data-component='createAccountForm.accountTypeSelector']").each((index, domElement) => {
				var $element = $(domElement);
				if ($element.val() !== newValue) {
					$element.val(newValue);
				}
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	toggleInputStatus: function (formParentId, disabled) {
		Dispatcher.dispatch({
			actionType: Constants.TOGGLE_CREATE_ACCOUNT_FORM_INPUTS,
			formParentId,
			disabled
		});
	},

	initializePhoneNumberGroupComponent: function(loggedInUserCountry, $parentComponent) {
		PhoneNumberHelper.initializePhoneNumberGroupComponent(loggedInUserCountry || this.getDefaultCountry(), $parentComponent);
	},

	initializeProductDownloadUrl: function() {
		var $downloadLinksMissingHref = $("[data-component='productTransactionHistory'] a[data-dynamic-href='downloadUrl'][href='']");

		$downloadLinksMissingHref.off("click.download");
		$downloadLinksMissingHref.on("click.download", AccountActions.promptForUndownloadableProduct);
	},

	promptForUndownloadableProduct: function (event) {
		if (!event || !event.target) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		BootstrapPrompt.alert(AccountStore.getWizardValue(
			WizardConstants.WIZARDS.PRODUCT_DOWNLOAD_DISPLAY_MESSAGES,
			WizardConstants.PRODUCT_DOWNLOAD_MESSAGE_FIELDS.UNDOWNLOADABLE_ERROR
		));
	},

	initializeSpouseInformationComponent: function () {
		var $spouseInfoForm = $("[data-component='spouseInformation'] form");

		$spouseInfoForm.off("submit.spouseInformation");
		$spouseInfoForm.on("submit.spouseInformation", AccountActions.changeSpouseInformation.bind(this));
	},

	redirectToSecureProject: function (project) {
		project = project || {};

		var secureProjectSessionKey = "secure-project";

		var value = {
			secureMatchingText: project.projectCode,
			frequency: "O",
			amount: project.amount,
			isOtherSelected: true,
			pledgeId: project.pledgeId,
			relatedAccount: project.relatedAccount
		};

		sessionStorage.setItem(secureProjectSessionKey, JSON.stringify(value));

		window.location = "/s-donate";
	},

	createCommunication: function (event) {
		AccountCommunicationsHelper.createCommunication(event);
	},

	_setSmartyStreetsFields: function (data, $form) {
		if (!data || !data.address) {
			return;
		}

		var standardizationStatus;
		var standardizationMessage;
		if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED) === "true") {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.USER_CERTIFIED;
		}
		else if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED) === "true") {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.VERIFIED;
		}
		else if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR)) {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.ERROR;
			standardizationMessage = $form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
		}

		if (standardizationStatus) {
			//Only adding a standardization result when this was either user or SmartyStreets verified or if we got an error so Services Address Standardization does not occur.
			data.address.standardizationResult = {
				status: standardizationStatus,
				message: standardizationMessage,
				provider: Constants.ADDRESS_VERIFICATION_PROVIDERS.SMARTYSTREETS
			};
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage);
	},
};

module.exports = AccountActions;
